<script setup lang="ts">
defineProps<{
  article: ArticleCard
}>()
</script>

<template>
  <NuxtLink
    :to="article.slug.full"
    class="article-card flex h-24 flex-col justify-center gap-2 px-4 text-lg text-green-50 no-underline sm:h-32 sm:px-7"
  >
    <UiCommonsTag :article="article" />
    <h5 class="my-[0.1rem]" v-text="article.title" />
  </NuxtLink>
</template>

<style scoped>
.article-card:hover {
  background-color: color-mix(in oklab, var(--color-coral-legacy-20) 100%, var(--color-white) 20%);
}
</style>
